import React, { useState, useEffect } from 'react';
import { IoArrowBackSharp, IoInformation } from 'react-icons/io5';
import { GrDocumentText } from 'react-icons/gr';
import { MdProductionQuantityLimits } from 'react-icons/md';
import { BASEAPIURL, token } from '../../env';

export default function BarDetail({setShowBardetail}) {
  const [selectedCard, setSelectedCard] = useState(null);
  const [products, setProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(false);

  const [filterStatus, setFilterStatus] = useState('All');
  const [searchName, setSearchName] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 8;

  const dummyData = {
    orders: [],
    reservations: [
      
    ],
  };

  useEffect(() => {
    if (selectedCard === 'products') {
      fetchProductList();
    }
  }, [selectedCard]);

  const fetchProductList = async () => {
    setLoadingProducts(true);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      tokenData: token,
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    try {
      const response = await fetch(`${BASEAPIURL}/ProductList`, requestOptions);
      const result = await response.json();
      const sortedProducts = (result.data || []).sort((a, b) =>
        a.ProdName.localeCompare(b.ProdName)
      );
      setProducts(sortedProducts);
    } catch (error) {
      console.error('Failed to fetch products:', error);
    } finally {
      setLoadingProducts(false);
    }
  };

  const filteredProducts = products
    .filter((p) => {
      if (filterStatus === 'Active') return !p.ProdIsDeactive;
      if (filterStatus === 'Inactive') return p.ProdIsDeactive;
      return true;
    })
    .filter((p) => p.ProdName.toLowerCase().includes(searchName.toLowerCase()));

  const paginatedProducts = filteredProducts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  const renderPagination = () => (
    <nav className="mt-3 ">
      <ul className="pagination">
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button className="page-link" onClick={() => setCurrentPage((p) => p - 1)}>
            Previous
          </button>
        </li>
        <br/>
        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <button className="page-link" onClick={() => setCurrentPage((p) => p + 1)}>
            Next
          </button>
        </li>
      </ul>
    </nav>
  );

  const renderTable = () => {
    if (!selectedCard) return null;

    if (selectedCard === 'products') {
      return (
        <div className=" pb-5 ">
          <h4>Product List</h4>

          <div className="row mb-3">
            <div className="col-md-4">
              <input
                type="text"
                placeholder="Search by name..."
                className="form-control"
                value={searchName}
                onChange={(e) => {
                  setSearchName(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
            <div className="col-md-4">
              <select
                className="form-select"
                value={filterStatus}
                onChange={(e) => {
                  setFilterStatus(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="All">All Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>

          {loadingProducts ? (
            <div>Loading Products...</div>
          ) : (
            <>
              <table className="table table-bordered table-hover table-striped">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Code</th>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Location</th>
                    <th>Full Price</th>
                    <th>Half Price</th>
                    <th>CGST %</th>
                    <th>SGST %</th>
                    <th>IGST %</th>
                    <th>Stock Wise</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedProducts.map((p) => (
                    <tr key={p.ProdID}>
                      <td>{p.ProdID}</td>
                      <td>{p.ProdCode}</td>
                      <td>{p.ProdName}</td>
                      <td>{p.ProdCateName}</td>
                      <td>{p.ProdLocName}</td>
                      <td>{p.ProdFullPrice}</td>
                      <td>{p.ProdHalfPrice}</td>
                      <td>{p.ProdCGSTPer}%</td>
                      <td>{p.ProdSGSTPer}%</td>
                      <td>{p.ProdIGSTPer}%</td>
                      <td>{p.ProdIsStockWise ? 'Yes' : 'No'}</td>
                      <td>{p.ProdIsDeactive ? 'Inactive' : 'Active'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {renderPagination()}
            </>
          )}
        </div>
      );
    }

    if (selectedCard === 'orders') {
      return (
        <div className="mt-4">
          <h4>List of Orders</h4>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>ID</th>
                <th>Order No</th>
                <th>Customer</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {dummyData.orders.map((o) => (
                <tr key={o.id}>
                  <td>{o.id}</td>
                  <td>{o.orderNo}</td>
                  <td>{o.customer}</td>
                  <td>{o.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    if (selectedCard === 'reservations') {
      return (
        <div className="mt-4">
          <h4>Reservations</h4>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Type</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {dummyData.reservations.map((r) => (
                <tr key={r.id}>
                  <td>{r.id}</td>
                  <td>{r.name}</td>
                  <td>{r.type}</td>
                  <td>{r.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
  };

  const productCount = products.length;
  const orderCount = dummyData.orders.length;
  const reservationCount = dummyData.reservations.length;

  const handleCardClick = (type) => {
    setSelectedCard(type);
    setCurrentPage(1);
    setFilterStatus('All');
    setSearchName('');
  };

  return (
    <div className="scroll-box">
      <div className="container mt-1">
         <button
        className="btn btn-light border mb-1"
        onClick={() => setShowBardetail(false)}
      >
      <IoArrowBackSharp size={26}/>
      </button>
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
            <div
              onClick={() => handleCardClick('products')}
              className={`card p-3 border-0 rounded-1`}
              style={{
                backgroundColor: selectedCard === 'products' ? '#d9f1ff' : '#fff',
                cursor: 'pointer',
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex bg-primary text-white justify-content-center align-items-center" style={{ width: 80, height: 80, borderRadius: 50 }}>
                  <MdProductionQuantityLimits style={{ fontSize: '2.5em' }} />
                </div>
                <div>
                  <div style={{ fontSize: '22px', fontWeight: 200, color: '#03a9f5' }}>Product List</div>
                  <div style={{ fontSize: '16px', fontWeight: 300, color: '#000' }}>{productCount}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
            <div
              onClick={() => handleCardClick('orders')}
              className={`card p-3 border-0 rounded-1`}
              style={{
                backgroundColor: selectedCard === 'orders' ? '#d0f9f1' : '#fff',
                cursor: 'pointer',
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex" style={{ backgroundColor: '#1de9b6', width: 80, height: 80, borderRadius: 50, alignItems: 'center', justifyContent: 'center' }}>
                  <GrDocumentText style={{ fontSize: '2.5em', color: '#fff' }} />
                </div>
                <div>
                  <div style={{ fontSize: '22px', fontWeight: 200, color: '#1de9b6' }}>List Of Orders</div>
                  <div style={{ fontSize: '16px', fontWeight: 300, color: '#000' }}>{orderCount}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
            <div
              onClick={() => handleCardClick('reservations')}
              className={`card p-3 border-0 rounded-1`}
              style={{
                backgroundColor: selectedCard === 'reservations' ? '#ffd6d6' : '#fff',
                cursor: 'pointer',
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex" style={{ backgroundColor: '#e74c3c', width: 80, height: 80, borderRadius: 50, alignItems: 'center', justifyContent: 'center' }}>
                  <IoInformation style={{ fontSize: '2.5em', color: '#fff' }} />
                </div>
                <div>
                  <div style={{ fontSize: '22px', fontWeight: 200, color: '#e74c3c' }}>Reservation</div>
                  <div style={{ fontSize: '16px', fontWeight: 300, color: '#000' }}>{reservationCount}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {renderTable()}
      </div>
    </div>
  );
}